import {
  CLEAN_USER,
  GET_USER,
  REFRESH_USER,
  SET_VIEWING_AS,
  SET_USER_DATA,
  RESET_VIEWING_AS,
  IS_SENDING_INFORMATION,
  SET_COMPLETED_TOUR_SECTIONS
} from 'constants/types';

const INITIAL_STATE = {
  zohoData: {},
  firebaseData: {},
  // agent whose profile is loaded: the requester, or the view-as target
  zohoId: '',
  // always the logged-in requester, kept for display while impersonating
  mainZohoId: '',
  viewAsAgent: null,
  // set by hydration when the stored slice was written mid view-as
  needsRefresh: false,
  isSendingInformation: false,
  completedTourSections: []
};

function userReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // view-as profile loaded: the requester identity stays untouched
    case GET_USER:
      return {
        ...state,
        ...action.payload,
        viewAsAgent: state.viewAsAgent,
        needsRefresh: false
      };
    case SET_USER_DATA:
      return {
        ...state,
        ...action.payload.data,
        mainZohoId: action.payload.mainZohoId,
        needsRefresh: false
      };
    case CLEAN_USER:
      return INITIAL_STATE;
    // only ever dispatched with the requester's own profile, so it repairs both ids
    case REFRESH_USER:
      return {
        ...state,
        zohoData: action.payload,
        zohoId: action.payload?.id ?? state.zohoId,
        mainZohoId: action.payload?.id ?? state.mainZohoId,
        needsRefresh: false
      };
    case SET_VIEWING_AS:
      return {
        ...state,
        viewAsAgent: action.payload,
        zohoId: action.payload
      };
    case RESET_VIEWING_AS:
      return {
        ...state,
        viewAsAgent: null
      };
    case IS_SENDING_INFORMATION:
      return {
        ...state,
        isSendingInformation: action.payload
      };
    case SET_COMPLETED_TOUR_SECTIONS:
      return {
        ...state,
        completedTourSections: action.payload
      };
    default:
      return state;
  }
}

export default userReducer;
